// src/util/recommendationBeautifier.js
const normalize = (str = '') => str
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()

export const beautify = (label = '') => {
  const norm = normalize(label)

  if (norm.startsWith('participar da palestra inform')) return null

  if (norm.includes('consulta com nutricionista')) {
    return '🍎 Agende sua consulta com a nutricionista para fortalecer sua saúde alimentar.'
  }

  if (norm.includes('academia unimed')) {
    return '💪 Mantenha seu corpo ativo frequentando a academia e aproveitando os benefícios da atividade física.'
  }

  if (norm.includes('exames laboratoriais')) {
    return '🧪 Realize seus exames laboratoriais, quando necessário, para acompanhar sua saúde de forma precisa.'
  }

  if (norm.includes('retorno a cada 3 meses')) {
    return '🩺 Faça acompanhamento médico com retorno a cada 3 meses para manter o cuidado sempre em dia.'
  }

  if (norm.includes('grupo pre-diab')) {
    return '👥 Participe do grupo Pré-Diabético e compartilhe experiências e aprendizados com outras pessoas na mesma jornada.'
  }

  if (norm.includes('acompanhamento a nivel ambulatorial')) {
    return '🏥 Mantenha o acompanhamento ambulatorial com nossa equipe, que está pronta para caminhar com você.'
  }

  if (norm.includes('acompanhamento nutricional a cada 3 meses')) {
    return '🍽️ Faça acompanhamento nutricional a cada 3 meses para manter hábitos saudáveis sempre por perto.'
  }

  if (norm.includes('retorno medico a cada 6 meses') || norm.includes('retorno medico a cada 6')) {
    return '📅 Realize retorno médico a cada 6 meses para revisar exames, orientações e seguir firme no seu cuidado.'
  }

  if (norm.includes('endocrinologista')) {
    return '🧬 Consulte o endocrinologista, quando necessário, para acompanhar seu metabolismo e saúde hormonal.'
  }

  if (norm.includes('psicologo')) {
    return '🧠 Considere acompanhamento psicológico: cuidar da mente também é cuidar da sua qualidade de vida.'
  }

  if (norm.includes('psiquiatra')) {
    return '💛 Procure o psiquiatra, caso recomendado, para um cuidado completo da sua saúde emocional.'
  }

  if (norm.includes('papanicolau')) {
    return '🧫 Realize o exame Papanicolau anualmente para prevenção e cuidado com a saúde da mulher.'
  }

  if (norm.includes('ultrassonografia de mama') || norm.includes('ultrassom de mama')) {
    return '🩻 Realize ultrassonografia de mama quando indicado, reforçando o rastreio preventivo.'
  }

  if (norm.includes('sangue oculto nas fezes')) {
    return '🧪 Faça o exame de sangue oculto nas fezes para avaliação preventiva da saúde intestinal.'
  }

  if (norm.includes('avaliacao clinica no ambulatorio essencial')) {
    return '👨‍⚕️ Agende avaliação clínica, especialmente se houver histórico familiar relevante.'
  }

  if (norm.includes('consulta com clinico especifico')) {
    return '🩺 Agende consulta com o clínico específico, quando necessário, para avaliações direcionadas.'
  }

  if (norm.includes('colonoscopia')) {
    return '🧿 Realize a colonoscopia, quando recomendada, para prevenção e acompanhamento da saúde intestinal.'
  }

  if (norm.includes('gastroenterologista')) {
    return '🩻 Mantenha acompanhamento com o gastroenterologista uma vez ao ano, conforme indicação médica.'
  }

  if (!label) return null

  return `✨ ${label}`
}
